import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_2 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_3 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_4 = { class: "subtitle-1 font-weight-medium" }
const _hoisted_5 = {
  key: 0,
  style: {"max-height":"86vh","overflow-y":"auto"},
  id: "InvoiceDocumentValidation"
}
const _hoisted_6 = { class: "image-display" }
const _hoisted_7 = ["viewBox"]
const _hoisted_8 = ["xlink:href", "height", "width"]
const _hoisted_9 = {
  key: 1,
  class: "d-flex justify-center",
  style: {"height":"calc(100vh - 180px)","overflow-y":"auto"},
  id: "InvoiceDocumentValidation"
}
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_ossPdf = _resolveComponent("ossPdf")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_ctx.document)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        fluid: "",
        class: "d-flex flex-column pa-2",
        style: {"width":"100vw"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window, {
            modelValue: _ctx.step,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step) = $event)),
            horizontal: "",
            style: {"max-height":"calc(100vh - 180px)"}
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      (_ctx.document.status)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 0,
                            cols: "12",
                            class: "pa-2 mb-2 oss-list-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "py-2 pl-3" }, {
                                    default: _withCtx(() => [
                                      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text--secondary font-weight-regular" }, " Statut ", -1)),
                                      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('document.status.'+_ctx.document.status)), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.document.name)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 1,
                            cols: "12",
                            class: "pa-2 mb-2 oss-list-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "py-2 pl-3" }, {
                                    default: _withCtx(() => [
                                      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text--secondary font-weight-regular" }, " Nom du document ", -1)),
                                      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.document.name), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.document.date)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 2,
                            cols: "12",
                            class: "pa-2 mb-2 oss-list-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "d-flex flex-column py-2 pl-3" }, {
                                    default: _withCtx(() => [
                                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text--secondary font-weight-regular" }, " Date du document ", -1)),
                                      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.formatDate), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.document.type)
                        ? (_openBlock(), _createBlock(_component_v_col, {
                            key: 3,
                            cols: "12",
                            class: "pa-2 mb-2 oss-list-item"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { "no-gutters": "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { class: "py-2 pl-3" }, {
                                    default: _withCtx(() => [
                                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text--secondary font-weight-regular" }, " Type de document ", -1)),
                                      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.formatCategory), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
              (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
                default: _withCtx(() => [
                  (_ctx.isImage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          (_ctx.document)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 0,
                                id: "svg-document-validation",
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "100%",
                                viewBox: `0 0 ${_ctx.imageWidth} ${_ctx.imageHeight}`,
                                style: {"position":"absolute","width":"100%","left":"0","top":"0","background":"#fff"}
                              }, [
                                _createElementVNode("g", null, [
                                  _createElementVNode("image", {
                                    id: "svg-image-document-validation",
                                    "xlink:href": _ctx.document.signedUrl,
                                    x: "0",
                                    y: "0",
                                    height: `${_ctx.imageHeight}px`,
                                    width: `${_ctx.imageWidth}px`
                                  }, null, 8, _hoisted_8)
                                ])
                              ], 8, _hoisted_7))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : (_ctx.isPDF && _ctx.document.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_ossPdf, {
                            documentId: _ctx.document.id
                          }, null, 8, ["documentId"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_10, "Pas d'affichage prevu pour ce document"))
                ]),
                _: 1
              }))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "pa-2"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    rounded: "",
                    elevation: "0",
                    style: {"width":"55%"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onStep())),
                    size: "small"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.step ? "Voir les informations" : "Voir le document"), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}